<template>
  <div style="white-space: normal">
    <v-dialog
      v-model="dialog"
      :width="dialogWidth"
      :fullscreen="$vuetify.breakpoint.xs"
      scrollable
    >




      <!-- Aktywator (możesz usunąć jeśli chcesz sterować tylko z rodzica) -->
<!--      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Projekt „Rappelkiste”
        </v-btn>
      </template>-->
      <v-card v-if="projektNr == 0" class="portfolio__dialog-card rounded-xl overflow-y-auto ">
          <v-btn large icon @click="dialog = false" class=" align-self-end mr-1 mt-1   close-btn" >
            <v-icon md>mdi-close</v-icon>
          </v-btn>

<section id="datenschutz" class="px-10">
  <h1>Datenschutz</h1>
  <h2>Datenschutzerklärung</h2>

  <p>
    Wir freuen uns, dass Sie unsere Website besuchen und bedanken uns für Ihr Interesse.
    Wir nehmen Ihren Datenschutz sehr ernst und behandeln Ihre personenbezogenen Daten
    vertraulich und entsprechend den gesetzlichen Vorschriften.
  </p>

  <p>
    Im Folgenden informieren wir Sie über den Umgang mit Ihren personenbezogenen Daten
    bei Nutzung unserer Website. Personenbezogene Daten sind hierbei alle Daten, mit
    denen Sie persönlich identifiziert werden können.
  </p>

  <h3>Verantwortliche Stelle</h3>
  <p>
    Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
  </p>

  <p>
    <strong>Piotr Moskaluniec – m²Architekt</strong><br>
    Alt-Friedrichsfelde 12<br>
    E-Mail:
    <a href="mailto:piotrasmc@gmail.com">piotrasmc@gmail.com</a>
  </p>

  <p>
    Die verantwortliche Stelle entscheidet allein oder gemeinsam mit anderen über die
    Zwecke und Mittel der Verarbeitung von personenbezogenen Daten
    (z.&nbsp;B. Namen, Kontaktdaten o. Ä.).
  </p>

  <h3>Datenverarbeitung beim Besuch unserer Website</h3>
  <p>
    Der Provider der Seiten erhebt und speichert automatisch Informationen in
    sogenannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt.
    Dies sind:
  </p>

  <ul>
    <li>Browsertyp und Browserversion</li>
    <li>Datum und Uhrzeit der Serveranfrage</li>
    <li>Referrer URL</li>
    <li>Hostname des zugreifenden Rechners</li>
    <li>IP-Adresse</li>
  </ul>

  <p>
    Die Verarbeitung erfolgt gemäß Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;f DSGVO auf Grundlage
    unseres berechtigten Interesses an der Verbesserung der Stabilität und
    Funktionalität unserer Website.
  </p>

  <h3>Cookies</h3>
  <p>
    Diese Website verwendet keine Cookies.
  </p>

  <h3>Kontaktaufnahme</h3>
  <p>
    Wenn Sie uns per E-Mail oder über ein Kontaktformular kontaktieren, werden die von
    Ihnen gemachten Angaben (z.&nbsp;B. Name, E-Mail-Adresse, Telefonnummer) zum Zwecke
    der Bearbeitung der Anfrage sowie für den Fall von Anschlussfragen bei uns
    gespeichert.
  </p>

  <p>
    Rechtsgrundlage für die Verarbeitung der Daten ist unser berechtigtes Interesse
    an der Beantwortung Ihres Anliegens gemäß Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;f DSGVO.
    Eine Weitergabe dieser Daten findet ohne Ihre Einwilligung nicht statt.
  </p>


  <h3>Weitergabe von Daten</h3>
  <p>
    Eine Übermittlung Ihrer personenbezogenen Daten an Dritte erfolgt nur, wenn dies
    im Rahmen der Vertragsabwicklung notwendig ist oder Sie ausdrücklich eingewilligt
    haben. Eine Weitergabe Ihrer Daten zu Zwecken der Werbung findet nicht statt.
  </p>

  <h3>Ihre Rechte</h3>
  <p>Sie haben hinsichtlich der Sie betreffenden personenbezogenen Daten das Recht:</p>

  <ul>
    <li>auf Auskunft,</li>
    <li>auf Berichtigung oder Löschung,</li>
    <li>auf Einschränkung der Verarbeitung,</li>
    <li>auf Widerspruch gegen die Verarbeitung,</li>
    <li>auf Datenübertragbarkeit.</li>
  </ul>

  <p>
    Darüber hinaus haben Sie das Recht, sich bei einer zuständigen
    Datenschutz-Aufsichtsbehörde über die Verarbeitung Ihrer personenbezogenen Daten
    zu beschweren.
  </p>

  <p>
    <strong>Stand:</strong> 22.11.2025
  </p>

  <hr>

  <p>
    Betrieben von<br>
    <strong>m²Architekt – Piotr Moskaluniec</strong><br>

  </p>
</section>


      </v-card>
      <v-card v-else-if="projektNr == 100" class="portfolio__dialog-card rounded-xl overflow-y-auto">
          <v-btn large icon @click="dialog = false" class="align-self-end mr-1 mt-1   close-btn" >
            <v-icon md>mdi-close</v-icon>
          </v-btn>


<section class="px-10 pb-10" style="max-width: 800px; margin: auto;">

  <h1 style="text-align:left; margin-bottom: 0.3em;">Impressum</h1>
  <p style="color:#555;">
    <em>für die Website <strong>m2architekt.site</strong></em>
  </p>

  <h2 style="margin-top:2em;">Angaben gemäß § 5 TMG</h2>

  <p>
    <strong>Piotr Moskaluniec</strong><br>
    Alt-Friedrichsfelde 23<br>
    10315 Berlin<br>
    Deutschland
  </p>

  <h2 style="margin-top:2em;">Kontakt</h2>

  <p>
    <strong>E-Mail:</strong><br>
    <a href="mailto:piotrasmc@gmail.com" style="color:#333; text-decoration:none;">
      piotrasmc@gmail.com
    </a>
  </p>

  <h2 style="margin-top:2em;">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>

  <p>
    <strong>Piotr Moskaluniec</strong><br>
    Alt-Friedrichsfelde 23<br>
    10315 Berlin
  </p>

  <h2 style="margin-top:2em;">Haftungsausschluss</h2>

  <h3 style="margin-top:1.2em;">Haftung für Inhalte</h3>
  <p>
    Die Inhalte dieser Website wurden mit größter Sorgfalt und viel Liebe zum
    Detail zusammengestellt. Trotz aller Bemühungen kann ich keine Gewähr für
    die Vollständigkeit, Aktualität oder absolute Fehlerfreiheit übernehmen.
    Gemäß § 7 Abs. 1 TMG bin ich für eigene Inhalte verantwortlich, jedoch
    nicht verpflichtet, fremde Informationen dauerhaft zu überwachen
    (§§ 8–10 TMG). Sollten Ihnen Unstimmigkeiten oder rechtliche Probleme
    auffallen, freue ich mich über einen Hinweis – betroffene Inhalte werden
    umgehend angepasst oder entfernt.
  </p>

  <h3 style="margin-top:1.2em;">Haftung für externe Links</h3>
  <p>
    Diese Website enthält gelegentlich Links zu externen Seiten, die zur
    Vertiefung oder Inspiration gedacht sind. Für deren Inhalte übernehme ich
    keine Verantwortung, da ich keinen Einfluss auf deren Gestaltung habe.
    Verantwortlich bleibt stets der jeweilige Betreiber der verlinkten Seite.
    Bei Bekanntwerden von Rechtsverletzungen werden diese Links selbstverständlich
    sofort entfernt.
  </p>

  <h2 style="margin-top:2em;">Urheberrecht / Bildrechte</h2>
  <p>
    Alle Texte, Grafiken und Projektfotos auf dieser Website wurden von mir
    persönlich erstellt und unterliegen dem deutschen Urheberrecht.
    Jede Vervielfältigung oder Weiterverwendung ist nur mit meiner ausdrücklichen
    Zustimmung erlaubt.
    Wenn Sie Interesse an der Nutzung einzelner Inhalte haben, sprechen Sie mich
    gerne an – ich freue mich über echtes Interesse an meiner Arbeit.
  </p>

</section>



      </v-card>
      <v-card v-else class="portfolio__dialog-card rounded-xl">
        <!-- Tytuł -->
        <v-card-title v-if="projektNr == 1" class="justify-space-between align-start">
          <div>
            <div class="text-h5 font-weight-bold text-break mr-10" style=" ">
              Kindertagesstätte Rappelkiste
            </div>
            <div class="subtitle-2 grey--text text--darken-1">
              Herbert-Tschäpe-Str. 2–4, Berlin-Lichtenberg · Umbau und Erweiterung
            </div>
          </div>

          <v-btn large icon @click="dialog = false" class="close-btn absolute" style="position : absolute">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-title v-if="projektNr == 2" class="justify-space-between align-start">
          <div>
            <div class="text-h5 font-weight-bold">
              Jugendkunstschule JUKS
            </div>
            <div class="subtitle-2 grey--text text--darken-1">
              Demminer Str. 4, Berlin-Hohenschönhausen · Umbau und Sanierung
            </div>
          </div>

          <v-btn large icon @click="dialog = false" class="close-btn absolute" style="position : absolute">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-title v-if="projektNr == 3" class="justify-space-between align-start">
          <div>
            <div class="text-h5 font-weight-bold">
              Ambulante Therapieeinrichtung KIDT
            </div>
            <div class="subtitle-2 grey--text text--darken-1">
              Demminer Str. 6, Berlin-Hohenschönhausen · Umbau und Sanierung
            </div>
          </div>

          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <!-- Karuzela zdjęć -->
        <v-card-text class="pt-0">
          <v-carousel
            class="portfolio__carousel mb-4"
            hide-delimiter-background
            show-arrows-on-hover
            :height="carouselHeight"
          >
            <v-carousel-item
              v-for="n in images.length"
              :key="n"
              :src="images[n-1]"
            />
<!--               :alt="`Rappelkiste – Bild ${n}`" -->
          </v-carousel>

          <!-- Opis projektu -->
          <v-container fluid class="py-0 px-1">
            <v-row v-if="projektNr == 1" dense>
              <!-- Kolumna „fakty” -->
              <v-col cols="12" md="5">
                <div class="project-meta">
                  <div><strong>Bauherr:</strong> Medi-Sport e.V.</div>
                  <div><strong>Baukosten:</strong> 2,8 Mio €</div>
                  <div><strong>Bauzeit:</strong> 2019–2020</div>
                  <div><strong>Umfang:</strong> NGF 1.042 m², BRI 5.257 m³</div>
                  <div><strong>Meine Tätigkeit:</strong> LPH 3–8</div>
                  <div><strong>Software:</strong> MicroStation, Orca, ArchiCAD, SketchUp</div>
                </div>
              </v-col>

              <!-- Kolumna opisowa -->
              <v-col cols="12" md="7">
                <p class="project-description mb-0">
                  Leistung: Um- und Ausbau bestehender Gebäudeteile, Aufstockung des Hintergebäudes
                  in Holzbauweise, Neubau eines Verbindungsgangs. Helles Eingangsfoyer über zwei
                  Etagen, Mehrzweckhalle im Erdgeschoss durch Einbeziehung des zuvor ungenutzten
                  Innenhofes. Extensive Dachbegrünung unterstützt das Regenwassermanagement und
                  schützt vor sommerlicher Hitze. Erweiterung um 60 Kitaplätze, Bauen bei laufendem
                  Betrieb.
                </p>
              </v-col>
            </v-row>

            <v-row v-if="projektNr == 2" dense>
              <!-- Kolumna „fakty” -->
              <v-col cols="12" md="5">
                <div class="project-meta">
                  <div><strong>Bauherr:</strong> Artki e.V.</div>
                  <div><strong>Baukosten:</strong> 1,5 Mio €</div>
                  <div><strong>Bauzeit:</strong> 2017–2018</div>
                  <div><strong>Umfang:</strong> NGF 1.520 m², BRI 5.261 m³</div>
                  <div><strong>Meine Tätigkeit:</strong> LPH 1–9</div>
                  <div><strong>Software:</strong> MicroStation, Orca, MS Projekt, SketchUp</div>
                </div>
              </v-col>

              <!-- Kolumna opisowa -->
              <v-col cols="12" md="7">
                <p class="project-description mb-0">
                  Leistung: Energetische Sanierung und barrierefreier Umbau einer
                  Plattenbau-Kunstschule im laufenden Betrieb. Einladende Umgestaltung
                  und Öffnung des Eingangsbereichs mit Luftraum, Schaffung großzügiger
                  und flexibler Grundrisse, Erweiterung mit zusätzlichen Werkstätten
                  im Keller sowie neuer Café- und Ausstellungsbereich mit Terrasse
                  zum Innenhof.
                </p>
              </v-col>
            </v-row>
            <v-row v-if="projektNr == 3" dense>
              <!-- Dane techniczne -->
              <v-col cols="12" md="5">
                <div class="project-meta">
                  <div><strong>Bauherr:</strong> K.I.D.T. gGmbH</div>
                  <div><strong>Baukosten:</strong> 0,5 Mio €</div>
                  <div><strong>Bauzeit:</strong> 2022</div>
                  <div><strong>Umfang:</strong> BGF 1.156 m², BRI 3.280 m³</div>
                  <div><strong>Meine Tätigkeit:</strong> LPH 1–9</div>
                  <div><strong>Software:</strong> MicroStation, Orca, MS Projekt</div>
                </div>
              </v-col>

              <!-- Opis projektu -->
              <v-col cols="12" md="7">
                <p class="project-description mb-0">
                  Leistung: Umbau und Sanierung einer ambulanten Therapieeinrichtung
                  in bestehender Gebäudestruktur. Anpassung der Raumfunktionen an
                  moderne therapeutische Anforderungen, Verbesserung der
                  Barrierefreiheit, Optimierung der Wegeführung und Schaffung heller,
                  freundlicher Aufenthaltsbereiche. Durchführung bei laufendem Betrieb
                  der Einrichtung.
                </p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <!-- Przyciski na dole -->
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            text
            @click="dialog = false"
          >
            Schließen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import marked from 'marked'
// import datenschutz from "datenschutz.txt";
export default {
  name: 'RapProjectDialog',

  props: {
    // sterowanie z rodzica przez :open.sync
    open: {
      type: Boolean,
      default: false,
    },
    projektNr: {
      type: Number,
      default: 0,
    },
  },

  data () {
    return {
      dialog: this.open,
      datenschutzText: "",
    }
  },

  computed: {
    compiledMarkdown() {
      return null
      // return marked.parse(this.datenschutzText);
    }  ,

    images(){
        let out = []
        if (this.projektNr == 1) {
        out = ["moreImages/RAP_1.jpg", "moreImages/RAP_2.jpg", "moreImages/RAP_3.jpg", "moreImages/RAP_4.jpg", "moreImages/RAP_5.jpg", "moreImages/RAP_6.jpg", "moreImages/RAP_7.jpg", "moreImages/RAP_8.jpg","images/projekt4.jpg"]
          }
        if (this.projektNr == 2) {
        out = [ "moreImages/JUKS_Farbkonzept_Straße2.png" , "moreImages/JUKS_Farbkonzept_Hof.png", "moreImages/JUKS_Farbkonzept_Straße.png"]
          }
        if (this.projektNr == 3) {
        out = ["images/projekt3x.jpg"]
          }
        return out
      },

    // szerokość okna zależna od breakpointu Vuetify
    dialogWidth () {
      const bp = this.$vuetify.breakpoint
      if (bp.xs) return '100%'   // telefon – pełna szerokość (i fullscreen = true)
      if (bp.sm) return '100%'      // małe tablety
      if (bp.md) return 900      // większe tablety / małe laptopy
      if (bp.lg) return 1100     // laptopy
      return 1300                // bardzo szerokie ekrany
    },

    // wysokość karuzeli zależna od szerokości ekranu
    carouselHeight () {
      return Math.min(window.innerHeight * 0.65 - 50 , 900)
    },
  },

  watch: {
    // gdy parent zmieni prop "open" → zaktualizuj lokalny dialog
    open (val) {
      this.dialog = val
    },
    // gdy użytkownik zamknie/otworzy dialog lokalnie → wyemituj do parenta
    dialog (val) {
      this.$emit('update:open', val)
    },
  },

  methods: {
    async loadDatenschutz() {
    const response = await fetch("/datenschutz.txt");
    if (!response.ok) {
      console.error("Nie mogę wczytać datenschutz.txt");
      return "";
    }
    return await response.text();
  },



  },

  async mounted(){
    // this.datenschutzText = await this.loadDatenschutz();
    }
}
</script>

<style scoped>
.close-btn {
  position: sticky;
  top: 8px;
  right: 8px;
  margin-left: auto;
  z-index: 50;
  background: rgba(255,255,255,0.7) !important;
  backdrop-filter: blur(4px);
}

.portfolio__dialog-card {
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.portfolio__carousel {
  border-radius: 12px;
  overflow: hidden;
}

.project-meta {
  font-size: 14px;
  line-height: 1.5;
}

.project-meta > div + div {
  margin-top: 4px;
}

.project-description {
  text-align: justify;
  line-height: 1.7;
  font-size: 14px;
}
</style>
